import { useUserInfosStore } from "@/stores/userInfosStore";

const getApiV3WithDivision = (divisionId?: number, organizationId?: number, apiUrl?: string) => {
  const userInfo = useUserInfosStore();
  const endpointWithDivision = true;
  return userInfo.getApiV3Bisom(endpointWithDivision, divisionId, organizationId, apiUrl);
};

const getApiV3WithoutDivision = (organizationId?: number) => {
  const userInfo = useUserInfosStore();
  const endpointWithDivision = false;
  return userInfo.getApiV3Bisom(endpointWithDivision, undefined, organizationId);
};

export { getApiV3WithDivision, getApiV3WithoutDivision };
